<template>
  <div class="owl360_ico" v-bind="$attrs">
    <img :src="iconSrc" alt="Icon" />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconSrc() {
      return require(`@/assets/img/${this.data}.png`);
    },
  },
  inheritAttrs: false, // Para evitar que $attrs aplique al div raíz automáticamente
};
</script>

<style scoped>
.owl360_ico img {
  display: inline-block;
  width: 46px !important;
  height: 46px !important;
}
.owl360_ico img {
  width: 46px;
  height: 46px;
  object-fit: contain; /* Ajusta a 'cover' o 'fill' según tus necesidades */
  max-width: 46px !important; /* Asegura que la imagen no se salga del contenedor */
  max-height: 46px !important; /* Asegura que la imagen no se salga del contenedor */
}
</style>
